import { FC, useState } from 'react'
import { useMutation } from '@apollo/client'
import { Button } from '@/atoms/Button'
import { CheckBoxBlankIcon } from '@/atoms/Icons/CheckBoxBlankIcon'
import { CheckBoxIconFilled } from '@/atoms/Icons/CheckBoxIconFilled'
import { CloseIcon } from '@/atoms/Icons/CloseIcon'
import { PayItForwardIcon } from '@/atoms/Icons/PayItForwardIcon'
import { Input } from '@/atoms/Input'
import { CaptionSM, ParagraphSM, TitleSM } from '@/atoms/Text'
import { Modal } from '@/molecules/Modal'
import { updateContributorOptInMutation } from '@/services/PifService/PifService'
import { useUser } from '@/services/UserService'
import { UpdateProjectSupporterMutation } from '@/types/codegen-federation'
import { Translate, useTranslate } from '@/utils/translate/translate-client'

interface Props {
  displayName?: string
}

export const PayItForwardContributorOptin: FC<Props> = ({ displayName }) => {
  const { user } = useUser()
  const [showBanner, setShowBanner] = useState(true)
  const [name, setName] = useState(
    user?.profile ? `${user.profile.firstName} ${user.profile.lastName}` : displayName ? displayName : '',
  )
  const [isOptedIn, setIsOptedIn] = useState(true)
  const isValidForm = name.length > 0 && isOptedIn

  const onClose = () => {
    setShowBanner(false)
  }

  return (
    <>
      <Modal onClose={onClose} isOpen={showBanner} className="block">
        <OptinForm
          onClose={onClose}
          name={name}
          setName={setName}
          isOptedIn={isOptedIn}
          setIsOptedIn={setIsOptedIn}
          isValidForm={isValidForm}
        />
      </Modal>
      {/* <div
        className={classNames([
          'fixed z-[1000] w-full p-3 left-0 h-fit bottom-0 bg-white rounded-t-2xl transition-all translate-y-full duration-500 lg:hidden',
          showBanner ? '!translate-y-0' : '',
        ])}
      >
        <OptinForm
          onClose={onClose}
          name={name}
          setName={setName}
          isOptedIn={isOptedIn}
          setIsOptedIn={setIsOptedIn}
          isValidForm={isValidForm}
        />
      </div> */}
    </>
  )
}

interface OptinFormProps {
  onClose: () => void
  name: string
  setName: (name: string) => void
  isOptedIn: boolean
  setIsOptedIn: (isOptedIn: boolean) => void
  isValidForm: boolean
}

const OptinForm: FC<OptinFormProps> = ({ onClose, name, setName, isOptedIn, setIsOptedIn, isValidForm }) => {
  const { t } = useTranslate('pif')

  const [updateContributor] = useMutation<UpdateProjectSupporterMutation>(updateContributorOptInMutation)

  const submitOptIn = () => {
    updateContributor({
      variables: {
        input: {
          projectSlug: 'sound-of-freedom',
          displayName: name,
          userShowOptIn: isOptedIn,
        },
      },
    })
    onClose()
  }

  return (
    <div>
      <div
        onClick={() => {
          onClose()
        }}
      >
        <CloseIcon size={24} className="ml-auto" />
      </div>
      <TitleSM color="core-gray-950" weight="bold" className="my-2">
        {t('optInHeader', 'Would you like to opt in to have your name be credited publicly?')}
      </TitleSM>
      <ParagraphSM color="core-gray-950" className="mb-4">
        If so, please tell use the name you’d like to be displayed.
      </ParagraphSM>
      <Input
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={t('enterYourName', 'Enter your name')}
        inputClasses="text-sm my-2 w-full border !border-core-gray-200 bg-core-gray-100 p-4 rounded-[14px] ring-0 focus:ring-0 focus:ring-offset-0 focus:ring-transparent focus:ring-offset-transparent focus:border-oxide focus:border-b-2"
        label=""
      />
      <CaptionSM color="core-gray-800" className="my-2">
        <Translate t={t} i18nKey="importantOptInNote">
          <b>Note:</b> Please choose something family friendly. First name with last initial is preferred. This
          information may be shared publicly.
        </Translate>
      </CaptionSM>
      <div className="my-4 flex items-center gap-3">
        <div onClick={() => setIsOptedIn(!isOptedIn)} className="cursor-pointer">
          {isOptedIn ? (
            <CheckBoxIconFilled size={24} color1="core-gray-950" />
          ) : (
            <CheckBoxBlankIcon size={24} color="core-gray-950" />
          )}
        </div>
        <CaptionSM color="core-gray-800">I agree to have my name displayed publicly as a contributor</CaptionSM>
      </div>
      <Button
        variant="oxide-primary"
        className="mb-4 mt-12 flex w-full gap-x-2 rounded-[14px]"
        disabled={!isValidForm}
        onClick={submitOptIn}
      >
        <PayItForwardIcon size={24} color={isValidForm ? 'white' : 'core-gray-400'} />
        {t('continue', 'Continue')}
      </Button>
    </div>
  )
}
